import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CaensError, CaensLoaded, CaensRequested } from './caens.actions';
import { ClientService } from '../../@core/data/clients/client.service';
import { co } from '@fullcalendar/core/internal-common';

@Injectable()
export class CaensEffects {
  constructor(
    private actions$: Actions,
    private clientService: ClientService
  ) {}

  requestCaens$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CaensRequested),
      mergeMap(() =>
        this.clientService.getCaens().pipe(
          map((res: any) => { 
            return CaensLoaded({ caens: res?.caens })}),
          catchError((error: any) => of(CaensError()))
        ) 
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CaensError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
